import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-200/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold text-foreground-950 mb-4">
              黑料爆料
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚网络热议猛料，涵盖娱乐圈、网红、明星等各领域内幕信息。真实可信，拒绝假消息，第一时间掌握最新爆料动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-accent-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                  免责声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-accent-500 transition-colors">
                  隐私政策
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                <span>tips@heiliaobaoliao.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500"></i>
                <span>严格保护爆料人隐私</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料爆料. 本站内容均来自网友投稿，不代表本站立场。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-accent-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-500 transition-colors" aria-label="RSS">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}